import { useRenderElement } from './useRenderElement.js';
/**
 * Returns a function that renders a Base UI component.
 * @deprecated use `useRenderElement` instead.
 */
export function useComponentRenderer(params) {
  const renderString = typeof params.render === 'string' ? params.render : undefined;
  const renderProp = typeof params.render === 'string' ? undefined : params.render;
  const renderElement = useRenderElement(renderString, {
    className: params.className,
    render: renderProp
  }, {
    ...params,
    props: params.extraProps
  });
  return {
    renderElement
  };
}